import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Hero from './components/Home/Hero';
import LeadForm from './components/Home/LeadForm';
import CarCatalog from './components/Home/CarCatalog';
import Financing from './components/Financing/Financing';
import Service from './components/Service/Service';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Taxis from './components/Taxis/Taxis';
import CarDetail from './components/CarDetail/CarDetail';
import TermsAndConditions from './components/TermsAndConditions/TermsAndConditions';
import Accessibility from './components/Accessibility/Accessibility';
import AccessibilityWidget from './components/AccessibilityWidget/AccessibilityWidget';
import TermsOfUse from './components/TermsOfUse/TermsOfUse';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import CookieConsent from './components/CookieConsent/CookieConsent';
import './App.css';

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <div className="app" dir="rtl" lang="he">
          <a href="#main-content" className="skip-link">דלג לתוכן הראשי</a>
          <Header />
          <main id="main-content" role="main" tabIndex="-1">
            <Routes>
              <Route path="/" element={
                <>
                  <Hero />
                  <LeadForm />
                  <CarCatalog />
                </>
              } />
              <Route path="/financing" element={<Financing />} />
              <Route path="/service" element={<Service />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/taxis" element={<Taxis />} />
              <Route path="/cars/:slug" element={<CarDetail />} />
              <Route path="/terms" element={<TermsAndConditions />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/accessibility" element={<Accessibility />} />
            </Routes>
          </main>
          <Footer />
          <AccessibilityWidget />
          <CookieConsent />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;